import React, {forwardRef} from "react";
import { Container, Table } from "react-bootstrap";
import BrainDiagram from "../BrainDiagram";

const PrintResults = forwardRef(({ formData, calculatedValues, timestamp }, ref) => {
    return (
        <Container ref={ref} className="print-results mt-5">
            <h1 className="heading-h1">10-20 Measurement Results</h1>

            {/* <h4>Input Measurements</h4> */}
            <Table className="input-measurements" striped bordered hover style={{ width: "100%", tableLayout: "fixed" }}>
                <thead>
                    <tr>
                        <th style={{ width: "70%" }}>MEASUREMENT</th>
                        <th style={{ width: "30%" }}>VALUE</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Nasion to Inion Distance</td>
                        <td>{formData.nasionToInion || "N/A"} cm</td>
                    </tr>
                    <tr>
                        <td>Preauricular to Preauricular Distance</td>
                        <td>{formData.preauricular || "N/A"} cm</td>
                    </tr>
                    <tr>
                        <td>Circumference</td>
                        <td>{formData.circumference || "N/A"} cm</td>
                    </tr>
                </tbody>
            </Table>
            <h5 className="generated-date">Generated: {timestamp || "N/A"}</h5>

            {/* <h4>Calculated Electrode Distances</h4> */}
            {/* <Table striped bordered hover style={{ width: "100%", tableLayout: "fixed" }}>
                <thead>
                    <tr>
                        <th style={{ width: "70%" }}>Electrode</th>
                        <th style={{ width: "30%" }}>Distance (cm)</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(calculatedValues).map(([key, value]) => (
                        <tr key={key}>
                            <td>{key.toUpperCase()}</td>
                            <td>
                                {value ? <span style={{ color: "red" }}>{value.toFixed(1)}</span> : "N/A"}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table> */}
            <div
                className="brain-diagram-print"
                style={{ maxWidth: "500px", margin: "20px auto", pageBreakInside: "avoid" }}
            >
                <BrainDiagram formData={formData} />
            </div>
        </Container>
    );
});

export default PrintResults;
